"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const importModule_1 = __importDefault(require("./importModule"));
const isNewable_1 = __importDefault(require("./validation/isNewable"));
const isDynamicModule_1 = __importDefault(require("./validation/isDynamicModule"));
const importDynamicModule_1 = __importDefault(require("./importDynamicModule"));
const getModuleMetadata_1 = require("./metadata/getModuleMetadata");
/**
 * @description This function is used to process imports.
 * It will group all imported providers from different modules with the same 'provide' property.
 * Then you can inject them as an array.
 */
function processImports(Module, imports) {
    const { container } = (0, getModuleMetadata_1.getModuleMetadata)(Module);
    const newableModules = imports.filter((item) => (0, isNewable_1.default)(item));
    const dynamicModules = imports.filter((item) => (0, isDynamicModule_1.default)(item));
    const allRefs = [];
    const reducedRefs = [];
    const groups = {};
    for (const item of dynamicModules) {
        allRefs.push(...(0, importDynamicModule_1.default)(item));
    }
    for (const item of newableModules) {
        allRefs.push(...(0, importModule_1.default)(item));
    }
    for (const ref of allRefs) {
        const key = ref.provide.toString();
        if (!groups[key]) {
            Object.assign(groups, {
                [key]: {
                    provide: ref.provide,
                    getters: [],
                },
            });
            groups[key].getters.push(ref.getValue);
        }
        else {
            groups[key].getters.push(ref.getValue);
        }
    }
    for (const key of Object.keys(groups)) {
        const group = groups[key];
        const multiple = group.getters.length > 1;
        const reducedRef = {
            provide: group.provide,
            multiple,
            getValue: () => {
                return multiple
                    ? group.getters.map((getter) => getter()).flat()
                    : group.getters[0]();
            },
        };
        reducedRefs.push(reducedRef);
        container.bindExportedProviderRef(reducedRef);
    }
    return reducedRefs;
}
exports.default = processImports;
